/**
 * ページ送りで中身を入れ替えるときの伏せ方
 *
 * @description 入れ替わりが一瞬だと、どこが変わったのか目で追えない。一度伏せてから
 *              戻すことで、同じ場所の中身が差し替わったことが分かるようにする。
 *
 *              目印の付け外しをJSでやるのは、JSが動かないときに伏せたままの
 *              中身が残らないようにするため。
 */

/** 伏せてから戻すまでの間(ms)。_common_parts.scss の transition と合わせる */
const FADE = 250;

/** 伏せているあいだ付ける印 */
const HIDING = 'is-swapping';

/** 遷移を当てる目印 */
const HOOK = 'data-swapfade';

/**
 * 動きを減らす設定かどうか
 *
 * @returns 減らす設定なら true
 */
const isReduced = (): boolean => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/**
 * 伏せられるようにする
 *
 * @param el 伏せたい要素
 * @returns {void}
 */
const armFade = (el: Element): void => {
    el.setAttribute(HOOK, '');
};

/**
 * 伏せる用意を外して、伏せた状態も戻す
 *
 * @param el 伏せたい要素
 * @returns {void}
 */
const disarmFade = (el: Element): void => {
    el.removeAttribute(HOOK);
    el.classList.remove(HIDING);
};

/**
 * 伏せる
 *
 * @description 動きを減らす設定なら伏せずにすぐ返す。遷移の終わりは
 *              待たずに時間で測る。伏せた先が画面外にあるなどで
 *              transitionend が来ないことがあるため
 * @param el 伏せたい要素
 * @returns 伏せ切ったら解決する約束
 */
const fadeOut = (el: Element): Promise<void> => {
    if (isReduced()) {
        return Promise.resolve();
    }

    el.classList.add(HIDING);

    return new Promise((done) => {
        window.setTimeout(done, FADE);
    });
};

/**
 * 戻す
 *
 * @param el 伏せた要素
 * @returns {void}
 */
const fadeIn = (el: Element): void => {
    el.classList.remove(HIDING);
};

export { armFade, disarmFade, fadeOut, fadeIn };
